module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Regular.d09549c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Regular/SFProDisplay-Regular.ttf
// module id = yEPy
// module chunks = 24